import firebase from "firebase/app";
import "firebase/auth";
import axios from "axios";

const config = {
  apiKey: "AIzaSyDtEvjF0MJXfbo7NzUhrD07n5SbNP5WTjo",
  authDomain: "test-firebase-fba55.firebaseapp.com",
  databaseURL: "https://test-firebase-fba55.firebaseio.com",
  projectId: "test-firebase-fba55",
  storageBucket: "test-firebase-fba55.appspot.com",
  messagingSenderId: "872120159127"
};

firebase.initializeApp(config);

const user = {
  install(Vue) {
    Vue.prototype.$auth = {
      signIn: function(store, email, password) {
        firebase
          .auth()
          .signInWithEmailAndPassword(email, password)
          .then(function(res) {
            let session = store.state.session;
            session.isAuth = true;
            session.uid = res.user.localId;
            session.err = null;
            store.commit("changeSession", session);
          })
          .catch(function(err) {
            console.log("Sign in error: ", err);
            let session = store.state.session;
            session.err = "Не верный email или пароль";
          });
      },
      signOut: function(store) {
        firebase
          .auth()
          .signOut()
          .then(function() {
            let session = store.state.session;
            session.isAuth = false;
            session.uid = null;
            store.commit("changeSession", session);
          })
          .catch(function(err) {
            console.log("Sign out error: ", err);
          });
      },
      isAuth: function(store) {
        firebase.auth().onAuthStateChanged(
          function(user) {
            if (user) {
              let session = store.state.session;
              session.uid = user.uid;
              session.isAuth = true;
              store.dispatch("startSession", session);
            } else {
              window.prerenderReady = true;
            }
          },
          function(err) {
            console.log(err);
          }
        );
      },
      reg: function(ctx) {
        firebase
          .auth()
          .createUserWithEmailAndPassword(
            ctx.form["email"],
            ctx.form["password"]
          )
          .then(async function(res) {
            let session = ctx.$store.state.session;
            session.isReg = true;
            ctx.$store.commit("changeSession", session);
            let obj = {
              email: ctx.form.email,
              name: ctx.form.name,
              city: ctx.form.city,
              phone_formatted: "+38 " + ctx.form.phone,
              phone:
                "+38" +
                ctx.form.phone
                  .replace("(", "")
                  .replace(")", "")
                  .replace(" ", "")
                  .replace(/-/g, ""),
              uid: res.user.uid,
              status: 2
            };
            //firebase.database().ref('/users/' + res.uid).set(ctx.form);
            try {
              await axios.post("/.netlify/functions/user-create", obj);
              ctx.$store.dispatch("loadUser");
            } catch (err) {
              console.log(err);
            }
          })
          .catch(function(error) {
            if (error.code === "auth/weak-password") {
              ctx.$store.state.session.err = {
                type: "password",
                msg: "Пароль слишком слабый!"
              };
            } else if (error.code === "auth/email-already-in-use") {
              ctx.$store.state.session.err = {
                type: "email",
                msg: "Этот email уже занят!"
              };
            } else if (error.code === "auth/invalid-email") {
              ctx.$store.state.session.err = {
                type: "email",
                msg: "Не верный формат email!"
              };
            } else {
              ctx.$store.state.session.err = {
                msg: error.message
              };
            }
            console.log("createUser", error);
          });
      }
    };
  }
};

export default user;
